export function getActionCompletedTime(state, actionType) {
    let initiatedTime;

    if (actionType !== undefined) {
        initiatedTime =
            state.widget.lastActionInitiatedTime ||
            state[actionType][`initiatedTime_${state.widget.activeAction.identifier}`];
    }

    if (!initiatedTime) return () => 0;

    return () => (new Date() - initiatedTime) / 1000;
}

export function getInitiatedTime(actionIdentifier, state) {
    const initiatedTime = {};
    initiatedTime[`initiatedTime_${actionIdentifier}`] =
        state[`initiatedTime_${actionIdentifier}`] || new Date();
    return initiatedTime;
}

export function getTimeFrom(fromDate) {
    return (new Date() - fromDate) / 1000;
}
